import {useUserBusinessDetails} from "@twigsby/client-data";
import {
    Card,
    CardLayoutType, ContentBlock,
    ContentLoader,
    FlexAlign,
    FlexGap,
    FlexJustify,
    StackHorizontal,
    StackVertical
} from "@twigsby/frontend-framework";
import React, {useEffect} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {SettingsActionType} from "../../../Components/Settings/SettingsTypes";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const BusinessDetails = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    const {
        status,
        data,
        error,
    } : {
        status: any,
        data: any,
        error: any,
        isFetching: any
    } = useUserBusinessDetails();

    useEffect(() => {
        updatePageMeta({
            title: t(`settings.sections.${"Business Details"}`)
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-md'}>
                <h2 className={'mb-0'}>{t(`settings.sections.${"Business Details"}`)}</h2>
            </StackHorizontal>

            <StackVertical gap={FlexGap.ExtraLarge}>
                <div>
                    <Card headerOptions={{
                        title: t('labels.general')
                    }}
                          type={CardLayoutType.SlimHeader} emptyBody={true}>
                        {status === "loading" ? (
                            <ContentLoader childHeight={'6em'} childCount={9} />
                        ) : status === "error" ? (
                            <ContentBlock error={true} title={error.name} content={error.message} />
                        ) : (
                            <>
                                {data.manualActions.map((item: SettingsActionType, index: number) =>
                                    <div className={'user-action'} key={`preferencesManualAction${index}`}>
                                        <div className={'fade'}>{item.label}</div>
                                        <div>{typeof item.value === 'string' ? item.value : item.value.map((entry: any, index: number) => <div key={`settingsEntry${index}`}>{entry}</div>) }</div>
                                    </div>
                                )}
                            </>
                        )}
                    </Card>
                </div>
            </StackVertical>
        </>
    )
}

export default BusinessDetails
